<template>
  <div class="p-5">
    <p>
      BRI is an online video streaming platform owned by
      BRI Entertainment Private Limited, BRI
      currently offers over 100,000 hours of TV content and movies across 9 languages, and every major sport covered live.
      Highly evolved video streaming technology and a high attention to quality of experience across devices and platforms, make BRI the most complete
      video destination for Over The Top (OTT) video consumers.
      Reach out!
    </p>
    <div align="center" class="mt-8">
      <v-row>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
                <v-icon class="fa">mdi-account-convert
                </v-icon>
                Helpline
              </h6>
              <h4>{{Helpline}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
                <i class="fa fa-envelope" /> Email ID
              </h6>
              <h4>{{Email_ID}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
                <v-icon class="fa">mdi-web</v-icon>Website
              </h6>
              <h4>{{Website}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Website: "www.bripl.net",
      Email_ID: "support@bhimariddhi.in",
      Helpline: "+91-7387126704 ,7755982688, 2312656977 ",
    };
  }
};
</script>
<style scoped>
  .part {
    padding: 20px;
  }
</style>